////////////////////////////////////////////////////////////////////////////////////
// Console logger for logging to the console
////////////////////////////////////////////////////////////////////////////////////

import { dev } from "$app/environment";
import dayjs from "dayjs";

class Logger {
  // types
  message: Message;
  now: string;
  close: string;

  // assignment
  constructor(message: Message) {
    this.message = message;
    this.now = dayjs().format("h:mm:ss:SSS");
    this.close = "\x1b[0m";
  }

  // dev only methods
  public dev(location: string) {
    const time = `\u001b[38;5;75m[${this.now}]${this.close}`;
    const source = `\u001b[38;5;186m[${location ?? ""}]${this.close}`;
    if (dev) {
      console.log(`😎 ${time} ${source} ${this.message}${this.close}`);
    }
  }

  public warn(location: string) {
    const time = `\x1b[31m[${this.now}]${this.close}`;
    const source = `\u001b[38;5;186m[${location ?? ""}]${this.close}`;
    if (dev) {
      console.log(`🤢 ${time} ${source} \x1b[31m${this.message}${this.close}`);
    }
  }

  public success(location: string) {
    const time = `\u001b[38;5;82m[${this.now}]${this.close}`;
    const source = `\u001b[38;5;186m${location ?? ""} -> ${this.close}`;
    // show for all logs
    console.log(
      `😍 ${time} ${source} \u001b[38;5;82m${this.message}${this.close}`,
    );
  }

  public record(location: string) {
    const time = `\u001b[38;5;75m[${this.now}]${this.close}`;
    const source = `\u001b[38;5;186m[${location ?? ""}]${this.close}`;
    // show for all logs
    console.log(
      `📖 ${time} ${source} \u001b[38;5;82m${this.message}${this.close}`,
    );
  }

  public debug(location: string) {
    const time = `\u001b[38;5;75m[${this.now}]${this.close}`;
    const source = `\u001b[38;5;186m[${location ?? ""}]${this.close}`;
    // show for all logs
    console.log(
      `📖 ${time} ${source} \u001b[38;5;82m${this.message}${this.close}`,
    );
  }

  public email(location: string) {
    const time = `\u001b[38;5;75m[${this.now}]${this.close}`;
    const source = `\u001b[38;5;186m[${location ?? ""}]${this.close}`;
    // show for all logs
    console.log(
      `📨 ${time} ${source} \u001b[38;5;82m${this.message}${this.close}`,
    );
  }

  public api(location: string) {
    const time = `\u001b[38;5;75m[${this.now}]${this.close}`;
    const source = `\u001b[38;5;87m${location ?? ""} -> ${this.close}`;
    // show for all logs
    console.log(
      `🚀 ${time} ${source} \u001b[38;5;225m${this.message}${this.close}`,
    );
  }

  public time(ms: number) {
    const time = `\u001b[38;5;78m[${ms}ms]`;
    if (dev) {
      console.log(`⌛ ${time} ${this.message}${this.close}`);
    }
  }

  public cookies(cookies: { [key: string]: any }) {
    for (const cookie in cookies) {
      const time = `\u001b[38;5;75m[${this.now}]${this.close}`;
      const source = `\u001b[38;5;186m[${cookie ?? ""}]${this.close}`;
      console.log(
        `🍪 ${time} ${source} \u001b[38;5;82m${cookies[cookie]}${this.close}`,
      );
    }
  }
}

type Message = string | { [key: string]: string };

export const log = (message: Message) => {
  return new Logger(message);
};

export const lineBreak = () => {
  if (dev) {
    const line = "-".repeat(process.stdout.columns);
    console.log(line);
  }
};

export const lineBreakColor = () => {
  if (dev) {
    const line = "-".repeat(process.stdout.columns);
    console.log(`\x1b[33m${line}\x1b[0m`);
  }
};
export const lineBreakEnd = () => {
  if (dev) {
    const line = "-".repeat(process.stdout.columns);
    console.log(`\x1b[31m${line}\x1b[0m`);
  }
};

export const logHeader = (message: string) => {
  console.log(`\u001b[38;5;75m === ${message} === \x1b[0m`);
};
